import LegendIcon from '~/shared/assets/icons/line-chart-legend.svg';

export default function Legends() {
  return (
    <div
      id="legend-container"
      className="h-[36px] absolute bottom-[0px] mb-[-18px] w-full flex justify-center"
    >
      <div className="flex gap-[32px] h-fit items-center">
        <div className="flex gap-[8px] h-fit items-center">
          <LegendIcon className="w-[24px] h-[24px] fill-[#06D727]" />
          <div className="text-[16px] leading-[24px] font-bold text-[#949EAC] tracking-[-0.397px]">
            Utilized
          </div>
        </div>
        <div className="flex gap-[8px] h-fit items-center">
          <LegendIcon className="w-[24px] h-[24px] fill-[#2151F5]" />
          <div className="text-[16px] leading-[24px] font-bold text-[#949EAC] tracking-[-0.397px]">
            Size
          </div>
        </div>
      </div>
    </div>
  );
}
